import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Caption1, Link, PencilSmallIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import Angie from "~/utils/angie";
import { CommentHistoryDialog } from "./CommentHistoryDialog";
import Ago from "../component.ago";
import { useSecurity } from "../Hooks";
import UserLink from "../UserLink/UserLink";
const LastEdited = ({ comment }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const can = useSecurity();

  const canViewEdited = can(["view-edited"], comment);

  const handleOpenDialog = useCallback(() => {
    Angie.logger?.info("comment_history_click", { parent_type: comment.parent_type }, true);
    setOpen(true);
  }, [comment.parent_type]);

  const handleCloseDialog = useCallback(() => {
    setOpen(false);
  }, []);

  if (!canViewEdited) {
    return null;
  }

  return (
    <>
      <div className="tw-flex tw-items-center tw-gap-1 tw-my-2">
        <PencilSmallIcon style={{ marginBottom: "-2px" }} />
        <Link
          data-testid="last-edited-link"
          variant="text link-gray"
          className="tw-w-fit"
          onClick={handleOpenDialog}
        >
          <Caption1 color="secondary">
            {t("Last edited")}
            {": "}
            <Ago
              timestamp={comment.last_modification_on}
              refresh
            />
          </Caption1>
        </Link>
        <Caption1 color="secondary">{"- "}</Caption1>
        <UserLink
          id={comment.last_modification_by_id}
          name={comment.last_modification_by_name}
          renderAs={Caption1}
          nameProps={{ color: "secondary" }}
          context="last edited"
          short
          hideAvatar
          notInteractive
        />
      </div>
      <CommentHistoryDialog
        open={open}
        onClose={handleCloseDialog}
        id={comment.id}
        parentType={comment.parent_type}
        parentId={comment.parent_id}
      />
    </>
  );
};

LastEdited.propTypes = {
  comment: PropTypes.any.isRequired,
};

export default LastEdited;
